import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { deleteCacheEntry } from './deleteCacheEntry';

/**
 * Deletes all references to Customer from the apollo cache including entries
 * that start with "$" which were automatically created by Apollo InMemoryCache.
 * By coincidence this rule additionally clears CustomerAddress entries, but
 * we'll need to keep this in mind by adding additional patterns as MyAccount
 * features are completed.
 *
 * @param {ApolloClient} client
 */
export var clearCustomerDataFromCache = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (client) {
    yield deleteCacheEntry(client, key => key.match(/^\$?Customer/));
  });
  return function clearCustomerDataFromCache(_x) {
    return _ref.apply(this, arguments);
  };
}();